import React from 'react';
import Bugsnag from '@bugsnag/js';
import BugsnagPluginReact from '@bugsnag/plugin-react';
import enviroment from './enviroment';

Bugsnag.start({
  apiKey: enviroment.BUGSNAG_KEY,
  version: enviroment.BUGSNAG_VERSION,
  plugins: [new BugsnagPluginReact()],
  enabledBreadcrumbTypes: ['error', 'manual', 'navigation', 'process', 'request', 'state', 'user']
});

const ErrorBoundary = Bugsnag.getPlugin('react').createErrorBoundary(React);

export default ErrorBoundary;
